import { Can } from '@/auth/guards';
import { PERMISSIONS } from '@/auth/permissions';
import { AlertSettingsCard } from '@/features/settings/AlertSettingsCard';
import { ChangePasswordCard } from '@/features/settings/ChangePasswordCard';
import { CounterUpiCard } from '@/features/settings/CounterUpiCard';
import { LanguageCard } from '@/features/settings/LanguageCard';
import { PharmacyProfileCard } from '@/features/settings/PharmacyProfileCard';
import { ProfileCard } from '@/features/settings/ProfileCard';
import { SecurityQuestionCard } from '@/features/settings/SecurityQuestionCard';
import { StoreSettingsCard } from '@/features/settings/StoreSettingsCard';

/**
 * Personal settings (profile, password, counter QR) are visible to everyone.
 * Store and alert settings are gated section by section — settings.view for
 * the store card (read-only without settings.edit), alerts.manage for the
 * alert card, since there's no view-only alert permission in the catalog.
 */
export function SettingsPage() {
  return (
    <div className="mx-auto max-w-2xl space-y-4">
      <h1 className="font-display text-3xl">Settings</h1>

      <ProfileCard />
      <ChangePasswordCard />
      <SecurityQuestionCard />
      <CounterUpiCard />
      <LanguageCard />

      <Can permission={PERMISSIONS.settingsView}>
        <StoreSettingsCard />
      </Can>

      <Can permission={PERMISSIONS.settingsView}>
        <PharmacyProfileCard />
      </Can>

      <Can permission={PERMISSIONS.alertsManage}>
        <AlertSettingsCard />
      </Can>
    </div>
  );
}